import React, { useState, useRef, useEffect } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  authenticate,
  encryptedString,
  GetSettingWorkSpaceByUserID,
} from "../../global/utils";
import "./LoginSignup.css";
import { useDispatch } from "react-redux";
import * as actions from "../../store/actionTypes";

import { LoginStatus } from "../../constants/Constants";

import { Redirect } from "react-router-dom";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

//loader
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";

import * as AppUrls from "../../constants/AppUrls";
import * as Constants from "../../constants/Constants";

import { useTranslation } from "react-i18next";

import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";
import KeyboardIcon from "../../assets/images/keyboard_icon.png";
import ico from "../../assets/images/Sharjah/ico-1.svg";
import ico2 from "../../assets/images/Sharjah/ico-2.svg";

import * as Helpers from "../../global/Helpers";

import * as utils from "../../global/utils";
import i18next from "i18next";

import { signal } from "@preact/signals-react";

// import { GoPerson } from "react-icons/go";
import { Person } from "react-bootstrap-icons";

import appStoreIcon from "../../assets/images/Sharjah/apple.png";
import googlePlayIcon from "../../assets/images/Sharjah/google.png";

// import TermsAndConditions from '../TermsAndConditions/TermsAndConditions'

import SpinnersLoadingSIP from "../SpinnersLoadingSIP/SpinnersLoadingSIP";

export const PasswordUser = signal("");
export const otpSessionId = signal("");

toast.configure();

function Login(props) {
  const abortController = new AbortController();
  //const counter = useSelector((state) => state)
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();
  /* static login: to be uncommented */
  /* localStorage.setItem("user", "FIT");
    localStorage.setItem("username", "FIT");
    localStorage.setItem("WebCode", "50"); */

  const androidUrl = localStorage.getItem(Constants.localStorageConstants.company_name) === "QSC" || localStorage.getItem(Constants.localStorageConstants.company_name) === "BHM" ? "https://play.google.com/store/games?hl=en"
    : "https://play.google.com/store/apps/details?id=com.fitoman.SIFS&hl=en";
  const iosUrl = localStorage.getItem(Constants.localStorageConstants.company_name) === "QSC" || localStorage.getItem(Constants.localStorageConstants.company_name) === "BHM" ? "https://www.apple.com/jo/app-store/"
    : "https://apps.apple.com/us/app/sifs-trading/id6743483239";
  let language = localStorage.getItem("language");

  if (
    language === "null" ||
    language === null ||
    language === undefined ||
    language === "undefined"
  ) {
    language = "en";
  }
  let fromLogin = localStorage.getItem("isLanguageSelectedFromLogin");
  if (
    fromLogin === "null" ||
    fromLogin === null ||
    fromLogin === undefined ||
    fromLogin === "undefined"
  ) {
    fromLogin = false;
  }

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [LanguageSelectedFromLogin, setLanguageSelected] = useState(language);
  const [isLanguageSelectedFromLogin, setIsLanguageSelectedFromLogin] =
    useState(fromLogin);
  const [passwordType, setPasswordType] = useState("password");
  const [isRememberMe, setIsRememberMe] = useState(false);
  const [isDisclaimerLogin, setisDisclaimerLogin] = useState(false);
  const [redirect, setRedirect] = useState(null);
  /* const [ipAddress, setIpAddress] = useState(""); */
  const [visible, setVisible] = useState(false);
  const [keyboardVisible, setKeyboardVisible] = useState(false);
  const [passwordDisabled, setPasswordDisabled] = useState(false);
  const [layout, setLayout] = useState("default");
  const [keyboardLanguage, setKeyboardLanguage] = useState("en");
  const keyboard = useRef();

  useEffect(() => {
    /* componentDidMount */
    localStorage.setItem("ipAddress", "");
    localStorage.setItem(
      "LanguageSelectedFromLogin",
      LanguageSelectedFromLogin
    );
    localStorage.setItem(
      "isLanguageSelectedFromLogin",
      isLanguageSelectedFromLogin
    );
    localStorage.setItem("Netconnected", false);
    if (localStorage.getItem("isRememberMe") === "true") {
      setUsername(localStorage.getItem("username"));
      // setPassword(localStorage.getItem("password"));
      setIsRememberMe(true);
    } else {
      setUsername("");
      setPassword("");
      setIsRememberMe(false);
    }
    GetDeviceConfigs();
    getIpAddress();
  }, []);

  const onChange = (input) => {
    setPassword(input);
    // console.log("Input changed", input);
  };

  const handleShift = () => {
    const newLayoutName = layout === "default" ? "shift" : "default";
    setLayout(newLayoutName);
  };

  const onKeyPress = (button) => {
    // console.log("Button pressed", button);
    if (button === "{shift}" || button === "{lock}") handleShift();
    if (button === "{ar}") {
      setKeyboardLanguage("ar");
    } else if (button === "{en}") {
      setKeyboardLanguage("en");
    }
  };

  var tokenId = "";

  // const errorNotify = (message) => {
  //     toast.error(message, {
  //         position: toast.POSITION.BOTTOM_CENTER,
  //         hideProgressBar: true,
  //         autoClose: Constants.errorNotifyDuration
  //     });
  // };

  // const successNotify = (message) => {
  //     toast.success(message, {
  //         position: toast.POSITION.BOTTOM_CENTER,
  //         hideProgressBar: true,
  //         autoClose: Constants.successNotifyDuration
  //     });
  // };

  function changeLanguageNew(e) {
    e.preventDefault();
    var newlang = "";
    if (LanguageSelectedFromLogin === "en") {
      newlang = "ar";
    } else {
      newlang = "en";
    }
    setLanguageSelected(newlang);
    setIsLanguageSelectedFromLogin(true);
    localStorage.removeItem("LanguageSelectedFromLogin");
    localStorage.removeItem("isLanguageSelectedFromLogin");
    localStorage.setItem("LanguageSelectedFromLogin", newlang);
    localStorage.setItem("isLanguageSelectedFromLogin", true);
    props.changeLanguageNew();
  }

  // function TermsAndConditionsPOPUP() {
  //     confirmAlert({
  //         customUI: ({ onClose }) => {
  //             return (
  //                 <div className={"custom-popup custom-scrollable TermsAndConditions-popup " + Helpers.getAppTheme()}  style={{height: "600px" , width: "600px"}} >
  //                     <div
  //                         className="custom-popup-header pt-2"
  //                         style={{
  //                             display: "flex",
  //                             flexDirection: i18next.language === "ar" ? "row-reverse" : "unset",
  //                         }}
  //                     >
  //                         <div style={{ fontSize: "14px" }} >
  //                             <strong className="lableCustomized">

  //                                 {t("TermsAndConditions")}
  //                             </strong>
  //                         </div>
  //                         <div

  //                         >

  //                         </div>
  //                     </div>
  //                     <div
  //                         className="custom-popup-body pt-2 pb-2 display-vertically"
  //                         style={{
  //                             height: "calc(100% - 45px)",
  //                             overflowY: "auto",
  //                             direction: "ltr",
  //                         }}
  //                     >
  //                         <TermsAndConditions />
  //                     </div>
  //                 </div>
  //             );
  //         },
  //     });
  // }
  function alreadyLoggedInFunc() {
    // tokenId = "1";
    // console.log("token id", tokenId);
    // callLoginApi();
    // return;
    var yes = t("Yes");
    var no = t("No");
    confirmAlert({
      title: "Confirm to submit",
      message: t("userAlreadyLoggedIn"),
      buttons: [
        {
          label: String(yes),
          onClick: () => {
            // console.log('Click Yes')
            tokenId = "1";
            // console.log("token id", tokenId);
            callLoginApi();
          },
        },
        {
          label: String(no),
          //onClick: () => console.log('Click No')
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!validate()) {
      return;
    }
    callLoginApi();
  }

  function NotEnableEtrade() {
    var msg = (
      <html
        style={{
          textAlign: LanguageSelectedFromLogin === "ar" ? "right" : "left",
        }}
      >
        <span
          style={{
            textAlign: LanguageSelectedFromLogin === "ar" ? "right" : "left",
          }}
        >
          {t("NotEnableEtrade1")}
          <a id="EnableEtradeLink" href="https://webtrade.alramz.ae">
            https://webtrade.alramz.ae
          </a>
          {t("NotEnableEtrade2")}
          800 RAMZ (7269) or email us at cs@alramz.ae
        </span>
      </html>
    );

    var yes = t("Yes");
    var no = t("ok");
    confirmAlert({
      title: "",
      message: msg,
      buttons: [
        // {
        //     label: String(yes),

        // },
        {
          label: String(no),
          //onClick: () => console.log('Click No')
        },
      ],
      closeOnEscape: false,
      closeOnClickOutside: false,
    });
  }

  function validate() {
    if (!username) {
      Helpers.errorNotify(
        t("Please_enter_username_and_try_again."),
        i18next.language
      );
      return false;
    }

    if (!password) {
      Helpers.errorNotify(
        t("Please_enter_password_and_try_again."),
        i18next.language
      );
      return false;
    }

    if (
      !isDisclaimerLogin &&
      localStorage
        .getItem(Constants.localStorageConstants.company_name)
        .toUpperCase() === "PIONEERS"
    ) {
      Helpers.errorNotify(t("DisclaimerRequired"), i18next.language);
      return false;
    }

    return true;
  }

  function rememberMeFunction() {
    // if (isRememberMe) {
    //     localStorage.setItem("password", password);
    // } else {
    //     Helpers.removeExistingItem("password")
    // }
  }
  const getUserSettings = () => {
    let response = GetSettingWorkSpaceByUserID();
    response
      .then((response) => {
        let data = response.data[0];

        if (
          data.WorkSpaceSettings !== undefined &&
          data.WorkSpaceSettings !== null &&
          data.WorkSpaceSettings !== ""
        ) {
          var res = JSON.parse(data.WorkSpaceSettings);
          localStorage.setItem("selectedProfile", res.selectedProfile);
          localStorage.setItem("theme", res.theme);
          localStorage.setItem("UserSettings", data.WorkSpaceSettings);

          dispatch({
            type: actions.SELECT_PREFERRED_SYMBOL,
            payload: {
              PreferredSymbol: res.PreferredSymbol,
            },
          });

          dispatch({
            type: actions.SELECT_PREFERRED_EXCHANGE,
            payload: {
              PreferredExchange: res.PreferredExchange,
            },
          });

          dispatch({
            type: actions.UPDATE_ENABLE_EXPAND_ROW,
            payload: {
              EnableExpandRow: res.expandRow === "Y" ? true : false,
            },
          });

          dispatch({
            type: actions.ENABLE_TRADE_TICKER,
            payload: {
              EnableTradeTicker: res.tradeTicker === "Y" ? true : false,
            },
          });

          dispatch({
            type: actions.ENABLE_ROUND_TICKER,
            payload: {
              EnableRoundTicker: res.RoundTicker === "Y" ? true : false,
            },
          });

          // if (i18n.language === "ar" && res.lang === "en")
          //     props.changeLanguageNew()
          // else if (i18n.language === "en" && res.lang === "ar")
          //     props.changeLanguageNew()
          // console.log("getUserSettings Login", data);
          saveSettings(data);
        }
      })
      .catch((error) => {
        console.log("error", error);
      });
  };

  function saveSettings(data) {
    console.log("saveSettings", data);
    var res = JSON.parse(data.WorkSpaceSettings);
    let settings = {
      lang: isLanguageSelectedFromLogin ? LanguageSelectedFromLogin : res.lang,
      theme: res.theme,

      expandRow: res.expandRow,
      PreferredSymbol: res.PreferredSymbol,
      PreferredExchange: res.PreferredExchange,
      selectedProfile: res.selectedProfile,
      tradeTicker: res.tradeTicker,
      RoundTicker: res.RoundTicker,
    };
    //console.log("Settings Successfully Updated Login", res.PreferredExchange);
    if (data !== undefined && data !== null) {
      let postdata = {
        profileUniqueID: data.profileUniqueID,
        ProfileID: data.ProfileID,
        ProfileName: data.ProfileName,
        ProfileNameAr: data.ProfileNameAr,
        ProfileSettings: data.ProfileSettings,
        WorkSpaceSettings: JSON.stringify(settings),
        WebCode: localStorage.getItem("WebCode"),
      };

      //console.log("Settings Successfully Updated Login postdata", postdata);
      var updateWorkSpaceSettings = utils.UpdateUserProfileSettings(postdata);
      updateWorkSpaceSettings
        .then((response) => {
          if (response.data) {
            //console.log("Settings Successfully Updated");
            // this.props.setUserSettings(settings)
            localStorage.setItem("UserSettings", JSON.stringify(settings));

            if (i18n.language === "ar" && settings.lang == "en")
              props.changeLanguageNew();
            else if (i18n.language === "en" && settings.lang === "ar")
              props.changeLanguageNew();
          } else {
            console.log(
              "Unsuccessfull Update Settings, please contact Administrator"
            );
          }
        })
        .finally(() => {
          if (abortController) abortController.abort();
        })
        .catch((error) => {
          console.log(
            "Unsuccessfull Update Settings, please contact Administrator"
          );
          if (abortController) abortController.abort();
        });
    }
  }

  const GetDeviceConfigs = () => {
    let getProfilesByUserIdResponse = utils.GetDeviceConfigs();
    getProfilesByUserIdResponse
      .then((response) => response.data)
      .then((data) => {
        localStorage.setItem("ForgotPasswordMethod", data.ForgotPasswordMethod);
        localStorage.setItem("DeviceConfigs", JSON.stringify(data));
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const getIpAddress = () => {
    //
    var getIpAddress = utils.getIpAddress();
    getIpAddress
      .then((response) => {
        var res = response;

        localStorage.setItem("ipAddress", res.data.IPv4);
      })
      .catch((error) => {
        localStorage.setItem("ipAddress", "");
        console.log(error.message);
      });
  };

  const callLoginApi = () => {
    setVisible(true);
    setPasswordDisabled(true);

    let options = { withCredentials: true };
    var response = authenticate(
      username,
      password,
      "",
      "",
      localStorage.getItem("ipAddress"),
      tokenId,
      "",
      "",
      "",
      "",
      "N",
      options
    );
    // console.log(response);
    response
      .then((response) => {
        setVisible(false);
        if (!keyboardVisible) setPasswordDisabled(false);
        //console.log("#Login rresponse", response.data);
        //console.log(response);
        var status = response.data["Status"];
        let isFirstLoggedIn = response.data["IsFirstLogin"];
        // if (isFirstLoggedIn === "Y") {

        //     localStorage.setItem("WebCode", response.data["WebCode"]);
        //     setRedirect(AppUrls.changePassword);
        //     return;
        // }

        if (status === null) {
          // errorNotify(t("somethingwentwrong"));
          Helpers.errorNotify(t("servicesIsDownMSG"), i18next.language);
          return;
        }

        switch (status) {
          case LoginStatus.Success:
            PasswordUser.value = encryptedString(password);

            if (isFirstLoggedIn === "Y") {
              localStorage.setItem("loginFirst", true);
              localStorage.setItem("WebCode", response.data["WebCode"]);
              localStorage.setItem(
                "ExpiredDocument",
                response.data["isExpiredDocument"]
              );
              localStorage.setItem(
                "isIndividual",
                response.data["isIndividual"]
              );
              // localStorage.setItem("passwordToOTp", encryptedString(password));
              otpSessionId.value = encryptedString(password);
              localStorage.setItem("validValue", "");
              localStorage.setItem("username", response.data["UserName"]);
              localStorage.setItem("user", JSON.stringify(response.data));
              localStorage.setItem("IsNormalLogin", true);
              localStorage.setItem(
                "isTermsAndConditions",
                response.data["isTermsAndConditions"]
              );
              localStorage.setItem("UpdateInfo", response.data["UpdateInfo"]);
              getUserSettings();
              setRedirect(AppUrls.changePassword);
              return;
            } else {
              localStorage.setItem("loginFirst", true);
              Helpers.successNotify(
                t("loggedinsuccessfully"),
                i18next.language
              );
              localStorage.setItem("user", JSON.stringify(response.data));
              localStorage.setItem("username", response.data["UserName"]);
              rememberMeFunction();
              localStorage.setItem("WebCode", response.data["WebCode"]);
              localStorage.setItem(
                "ExpiredDocument",
                response.data["isExpiredDocument"]
              );
              localStorage.setItem(
                "isIndividual",
                response.data["isIndividual"]
              );
              localStorage.setItem("isRememberMe", "" + isRememberMe);
              localStorage.setItem("IsNormalLogin", true);
              localStorage.setItem(
                "isTermsAndConditions",
                response.data["isTermsAndConditions"]
              );
              localStorage.setItem("UpdateInfo", response.data["UpdateInfo"]);
              getUserSettings();
              // if (response.data["isTermsAndConditions"] === "N" && localStorage.getItem(Constants.localStorageConstants.company_name).toUpperCase() === "IFS") {
              //     setRedirect(AppUrls.TermsAndConditions);
              // }
              // else {
              setRedirect(AppUrls.trading);
              //}
            }

            break;
          case LoginStatus.InvalidLogin:
            if (
              localStorage
                .getItem(Constants.localStorageConstants.company_name)
                .toUpperCase() === "SIFS"
            ) {
              setPassword("");
            }


            if (
              localStorage
                .getItem(Constants.localStorageConstants.company_name)
                .toUpperCase() === "BHM"
            ) {
              if (response.data["ErrorMsg"])
                Helpers.errorNotify(response.data["ErrorMsg"], i18next.language);
            } else {
              Helpers.errorNotify(t("invalidusernamepassword"), i18next.language);

            }
            break;
          case LoginStatus.invalidTokenID:
            if (
              localStorage
                .getItem(Constants.localStorageConstants.company_name)
                .toUpperCase() === "BHM"
            ) {
              if (response.data["ErrorMsg"])
                Helpers.errorNotify(response.data["ErrorMsg"], i18next.language);
            } else {
              Helpers.errorNotify(t("invalidToken"), i18next.language);

            }
            break;
          case LoginStatus.TokenSent:
            PasswordUser.value = encryptedString(password);
            Helpers.successNotify(t("tokenSent"), i18next.language);
            localStorage.setItem("WebCode", response.data["WebCode"]);
            localStorage.setItem("user", JSON.stringify(response.data));
            localStorage.setItem("username", response.data["UserName"]);
            // localStorage.setItem("passwordToOTp", encryptedString(password));
            otpSessionId.value = encryptedString(password);
            rememberMeFunction();
            localStorage.setItem("isRememberMe", isRememberMe);
            localStorage.setItem("isFirstLoggedIn", isFirstLoggedIn);
            localStorage.setItem(
              "ExpiredDocument",
              response.data["isExpiredDocument"]
            );
            localStorage.setItem("isIndividual", response.data["isIndividual"]);
            localStorage.setItem("IsNormalLogin", true);
            localStorage.setItem(
              "isTermsAndConditions",
              response.data["isTermsAndConditions"]
            );
            localStorage.setItem("UpdateInfo", response.data["UpdateInfo"]);
            setRedirect(AppUrls.otp);
            break;
          case LoginStatus.TokenExpire:
            if (
              localStorage
                .getItem(Constants.localStorageConstants.company_name)
                .toUpperCase() === "BHM"
            ) {
              if (response.data["ErrorMsg"])
                Helpers.errorNotify(response.data["ErrorMsg"], i18next.language);
            } else {
              Helpers.errorNotify(t("tokenExpire"), i18next.language);

            }
            break;
          case LoginStatus.noPermetions:
            if (
              localStorage
                .getItem(Constants.localStorageConstants.company_name)
                .toUpperCase() === "BHM"
            ) {
              if (response.data["ErrorMsg"])
                Helpers.errorNotify(response.data["ErrorMsg"], i18next.language);
            } else
              Helpers.errorNotify(t("nopermissions"), i18next.language);
            break;
          case LoginStatus.ExceedNoTrials:
            if (
              localStorage
                .getItem(Constants.localStorageConstants.company_name)
                .toUpperCase() === "BHM"
            ) {
              if (response.data["ErrorMsg"])
                Helpers.errorNotify(response.data["ErrorMsg"], i18next.language);
            } else
              Helpers.errorNotify(t("userLocked"), i18next.language);
            break;
          case LoginStatus.AlreadyLoggedIn: //Case: Already logged in
            alreadyLoggedInFunc();
            break;
          case LoginStatus.NotAgreeTermCondtion:
            if (
              localStorage
                .getItem(Constants.localStorageConstants.company_name)
                .toUpperCase() === "BHM"
            ) {
              if (response.data["ErrorMsg"])
                Helpers.errorNotify(response.data["ErrorMsg"], i18next.language);
            } else
              Helpers.errorNotify(t("notAgreeTermCondtion"), i18next.language);
            break;
          case LoginStatus.UnknowError:
            if (
              localStorage
                .getItem(Constants.localStorageConstants.company_name)
                .toUpperCase() === "BHM"
            ) {
              if (response.data["ErrorMsg"])
                Helpers.errorNotify(response.data["ErrorMsg"], i18next.language);
            } else
              Helpers.errorNotify(t("somethingwentwrong"), i18next.language);
            break;
          case LoginStatus.EnableEtrade:
            NotEnableEtrade();
            break;
          case LoginStatus.NotificationsSentToMobile:
            Helpers.successNotify(t("loggedinsuccessfully"), i18next.language);
            // localStorage.setItem("loginFirst", true);
            // localStorage.setItem("user", JSON.stringify(response.data));
            // localStorage.setItem("username", response.data["UserName"]);
            // rememberMeFunction();
            // localStorage.setItem("WebCode", response.data["WebCode"]);
            // localStorage.setItem(
            //   "ExpiredDocument",
            //   response.data["isExpiredDocument"]
            // );
            // localStorage.setItem("isIndividual", response.data["isIndividual"]);
            // localStorage.setItem("isRememberMe", "" + isRememberMe);
            // localStorage.setItem("IsNormalLogin", true);
            // localStorage.setItem(
            //   "isTermsAndConditions",
            //   response.data["isTermsAndConditions"]
            // );
            // localStorage.setItem("UpdateInfo", response.data["UpdateInfo"]);
            // //getUserSettings();

            localStorage.setItem("SessionID", response.data["SessionID"]);
            PasswordUser.value = encryptedString(password);
            // Helpers.successNotify(t("tokenSent"), i18next.language);
            localStorage.setItem("WebCode", response.data["WebCode"]);
            localStorage.setItem("user", JSON.stringify(response.data));
            localStorage.setItem("username", response.data["UserName"]);
            // localStorage.setItem("passwordToOTp", encryptedString(password));
            otpSessionId.value = encryptedString(password);
            rememberMeFunction();
            localStorage.setItem("isRememberMe", isRememberMe);
            localStorage.setItem("isFirstLoggedIn", isFirstLoggedIn);
            localStorage.setItem(
              "ExpiredDocument",
              response.data["isExpiredDocument"]
            );
            localStorage.setItem("isIndividual", response.data["isIndividual"]);
            localStorage.setItem("IsNormalLogin", true);
            localStorage.setItem(
              "isTermsAndConditions",
              response.data["isTermsAndConditions"]
            );
            localStorage.setItem("UpdateInfo", response.data["UpdateInfo"]);

            setRedirect(AppUrls.Verification);
            break;

          case LoginStatus.NotificationsSentToMobileFCM:
            Helpers.successNotify(t("loggedinsuccessfully"), i18next.language);
            // localStorage.setItem("loginFirst", true);
            // localStorage.setItem("user", JSON.stringify(response.data));
            // localStorage.setItem("username", response.data["UserName"]);
            // rememberMeFunction();
            // localStorage.setItem("WebCode", response.data["WebCode"]);
            // localStorage.setItem(
            //   "ExpiredDocument",
            //   response.data["isExpiredDocument"]
            // );
            // localStorage.setItem("isIndividual", response.data["isIndividual"]);
            // localStorage.setItem("isRememberMe", "" + isRememberMe);
            // localStorage.setItem("IsNormalLogin", true);
            // localStorage.setItem(
            //   "isTermsAndConditions",
            //   response.data["isTermsAndConditions"]
            // );
            // localStorage.setItem("UpdateInfo", response.data["UpdateInfo"]);
            localStorage.setItem("SessionID", response.data["SessionID"]);
            // //getUserSettings();
            sessionStorage.setItem("FCM_VERIFICATION_ACTIVE", "Y");
            PasswordUser.value = encryptedString(password);
            // Helpers.successNotify(t("tokenSent"), i18next.language);
            localStorage.setItem("WebCode", response.data["WebCode"]);
            localStorage.setItem("user", JSON.stringify(response.data));
            localStorage.setItem("username", response.data["UserName"]);
            // localStorage.setItem("passwordToOTp", encryptedString(password));
            otpSessionId.value = encryptedString(password);
            rememberMeFunction();
            localStorage.setItem("isRememberMe", isRememberMe);
            localStorage.setItem("isFirstLoggedIn", isFirstLoggedIn);
            localStorage.setItem(
              "ExpiredDocument",
              response.data["isExpiredDocument"]
            );
            localStorage.setItem("isIndividual", response.data["isIndividual"]);
            localStorage.setItem("IsNormalLogin", true);
            localStorage.setItem(
              "isTermsAndConditions",
              response.data["isTermsAndConditions"]
            );
            localStorage.setItem("UpdateInfo", response.data["UpdateInfo"]);


            setRedirect(AppUrls.VerificationFCM);
            break;


          default:
            var message = t("somethingwentwrong");
            if (response.data["ErrorMsg"])
              Helpers.errorNotify(message, i18next.language);
            break;
        }
      })
      .catch((error) => {
        setVisible(false);
        if (!keyboardVisible) setPasswordDisabled(false);
        console.log("error", error);
        Helpers.errorNotify(error.message, i18next.language);
      });
  };

  var hideLoader = "";
  if (visible) {
    hideLoader = "";
  } else {
    hideLoader = "hide-loader";
  }

  function signupBtnClicked() {
    setRedirect(AppUrls.signUp);
  }

  if (redirect !== null) {
    // if (
    //   localStorage
    //     .getItem(Constants.localStorageConstants.company_name)
    //     .toUpperCase() === "HORIZON"
    // ) {
    //   return <Redirect to={AppUrls.SellIPOShares} />;
    // } else
    return <Redirect to={redirect} />;
  }
  // else {
  //   if (
  //     localStorage
  //       .getItem(Constants.localStorageConstants.company_name)
  //       .toUpperCase() === "HORIZON"
  //   ) {
  //     return <Redirect to={AppUrls.SellIPOShares} />;
  //   }
  // }

  let requiredClass = "";

  let localizationBtnClass = "mt-2 mr-2";
  let localizationBtnFloat = "right";
  let paddingleft = "70px ";
  let paddingRight = "0px";
  let paddingleft2 = "63px ";
  let paddingRight2 = "0px";

  let background =
    "linear-gradient(310deg, #ebe3cf, #878787 48%, white 48%, #faf6f6 52%, #f3b21f 52%)";
  if (i18n.language === "ar") {
    localizationBtnClass = "mt-2 ml-2";
    localizationBtnFloat = "left";
    paddingleft = "0px ";
    paddingRight = "48px";
    background =
      "linear-gradient(310deg, #f3b21f, #f3b21f 60%, white 48%, #faf6f6 64%, #878787 22%)";
    paddingleft2 = "0px ";
    paddingRight2 = "11px";
  }

  let customLayout = {
    default: [
      "` 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
      "{tab} q w e r t y u i o p [ ] \\",
      "{lock} a s d f g h j k l ; ' {enter}",
      "{shift} z x c v b n m , . / {shift}",
      "{ar} @ {space}",
    ],
    shift: [
      "~ ! @ # $ % ^ & * ( ) _ + {bksp}",
      "{tab} Q W E R T Y U I O P { } |",
      '{lock} A S D F G H J K L : " {enter}',
      "{shift} Z X C V B N M < > ? {shift}",
      "{ar} @ {space}",
    ],
  };
  let arabicLayoutCustom = {
    default: [
      "ذ 1 2 3 4 5 6 7 8 9 0 - = {bksp}",
      "{tab} ض ص ث ق ف غ ع ه خ ح ج د \\",
      "{lock} ش س ي ب ل ا ت ن م ك ط {enter}",
      "{shift} ئ ء ؤ ر لا ى ة و ز ظ {shift}",
      "{en} @ {space}",
    ],
    shift: [
      "ّ ! @ # $ % ^ & * ) ( _ + {bksp}",
      "{tab} َ ً ُ ٌ لإ إ ‘ ÷ × ؛ < > |",
      '{lock} ِ ٍ ] [ لأ أ ـ ، / : " {enter}',
      "{shift} ~ ْ } { لآ آ ’ , . ؟ {shift}",
      "{en} @ {space}",
    ],
  };

  if (keyboardLanguage === "ar") {
    customLayout = arabicLayoutCustom;
  }

  let display = {
    "{ar}": "ar",
    "{en}": "en",
    "{tab}": "tab",
    "{bksp}": "backspace",
    "{lock}": "caps",
    "{shift}": "shift",
    "{space}": " ",
    "{enter}": "< enter",
  };

  let keyboardTheme = "hg-theme-default";
  if (localStorage.getItem("theme") !== null) {
    if (localStorage.getItem("theme") === "dark")
      keyboardTheme = "hg-theme-custom";
  }

  let keyboardVisibleDisplay = "none";

  if (keyboardVisible) {
    keyboardVisibleDisplay = "block";
    paddingleft = "0px ";
    paddingRight = "0px ";
    background =
      "linear-gradient(270deg, #ebe3cf, #878787 48%, white 48%, #faf6f6 52%, #f3b21f 52%)";
  }
  //
  if (Helpers.getCompanyName() === "UNITED") {
    background = background;
  } else {
    background = "none";
  }

  return (

    <div id="login" className="AuthCont" style={{ background: background }}>
      <form
        name="form"
        className="login_Form"
        onSubmit={(e) => handleSubmit(e)}
      >
        <input type="hidden" value="something" />
        <div className="center">
          <div className="form-group">
            <input
              tabIndex="1"
              className={"input-textbox " + requiredClass}
              type="text"
              name="username"
              placeholder={t("usernamePlaceholder")}
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onKeyDown={(e) => {
                const charCode = e.key.charCodeAt(0);
                if (charCode >= 0x0600 && charCode <= 0x06ff) {
                  e.preventDefault();
                }
              }}
              disabled={visible}
              autoComplete="new-password"
            />
            <Person className="userNameIcon" size={25} />

            {localStorage
              .getItem(Constants.localStorageConstants.company_name)
              .toUpperCase() === "GLOBAL" ||
              localStorage
                .getItem(Constants.localStorageConstants.company_name)
                .toUpperCase() === "UNITED" ? (
              <div style={{ float: "right" }}>
                <button
                  tabIndex="2"
                  type="button"
                  className={"link"}
                  style={{
                    marginLeft: "10px",
                    marginRight: "10px",
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: visible ? "not-allowed" : "pointer",
                  }}
                  onClick={(event) => {
                    event.preventDefault();

                    setRedirect(AppUrls.ForgotUsername);
                  }}
                >
                  {t("ForgotUsername")}
                </button>
              </div>
            ) : null}
          </div>
          <div className="form-group container-input-with-password">
            <input
              tabIndex="3"
              className="input-textbox input-password"
              type={passwordType}
              name="password"
              placeholder={t("passwordPlaceholder")}
              value={password}
              onChange={(e) => {
                const input = e.target.value;
                setPassword(input);
                if (keyboardVisible) keyboard.current.setInput(input);
              }}
              disabled={passwordDisabled}
              onKeyDown={(e) => {
                const charCode = e.key.charCodeAt(0);
                if (charCode >= 0x0600 && charCode <= 0x06ff) {
                  e.preventDefault();
                }
              }}
              autoComplete="new-password"
            />
            <i
              className={
                passwordType === "password" ? "fa fa-eye-slash" : "fa fa-eye"
              }
              aria-hidden="true"
              style={{
                fontSize: "20px",
                cursor: "pointer",
                right: i18n.language === "en" ? "65px" : "",
                left: i18n.language === "en" ? "" : "65px",
                position: "absolute",
                top: "17px",
                color: "black",
              }}
              onClick={(e) => {
                e.preventDefault();
                if (passwordType === "password") {
                  setPasswordType("text");
                } else {
                  setPasswordType("password");
                }
              }}
            ></i>
            <img
              className="password-keyboard"
              src={KeyboardIcon}
              alt=""
              onClick={(e) => {
                e.preventDefault();
                setKeyboardVisible(!keyboardVisible);
                setPasswordDisabled(!passwordDisabled);
                keyboard.current.setInput(password);
              }}
            />
          </div>
          <div
            className="mt-2 mb-2 KeyboardLogin"
            style={{ display: keyboardVisibleDisplay }}
          >
            <Keyboard
              keyboardRef={(r) => (keyboard.current = r)}
              layoutName={layout}
              onChange={onChange}
              onKeyPress={onKeyPress}
              theme={keyboardTheme}
              layout={customLayout}
              display={display}

            /* rtl={true} */
            />
          </div>
        </div>
        <div style={{ display: "inline-block", width: "100%" }}>
          <div className="container-center" style={{ float: "left" }}>
            <input
              tabIndex="4"
              type="checkbox"
              className="checkbox"
              checked={isRememberMe}
              onChange={(e) => setIsRememberMe(!isRememberMe)}
              disabled={visible}
            />
            <span className="checkbox-localized-text  fontSizeAR">
              {" "}
              {t("RememberMe")}
            </span>
          </div>

          <div style={{ float: "right" }}>
            <button
              tabIndex="5"
              type="button"
              className={"link"}
              style={{
                marginLeft: "10px",
                marginRight: "10px",
                backgroundColor: "transparent",
                border: "none",
                cursor: visible ? "not-allowed" : "pointer",
              }}
              onClick={(event) => {
                event.preventDefault();
                if (!visible) {
                  setRedirect(AppUrls.forgetPassword);
                }
              }}
            >
              {localStorage
                .getItem(Constants.localStorageConstants.company_name)
                .toUpperCase() === "SIFS"
                ? t("resetPassword")
                : t("ForgotPassword")}
            </button>
          </div>
        </div>

        <div className="DiscLoginDiv">
          <input
            tabIndex="9"
            type="checkbox"
            className="checkbox"
            checked={isDisclaimerLogin}
            onChange={(e) => setisDisclaimerLogin(!isDisclaimerLogin)}
            disabled={visible}
          />
          <div className="DisclaimerLogin">
            {" "}
            {t("DisclaimerLogin")}
            <a
              style={{ textDecoration: "underline" }}
              href="https://nweb.pioneers-securities.com/EtradeServices/uploads/more_info.pdf"
              target="_blank"
            >
              {t("MoreInformation")}{" "}
            </a>
          </div>
        </div>

        <div className="KYCLink">
          <a
            href={
              LanguageSelectedFromLogin === "ar"
                ? "https://www.intlsecurities.ae/ar/kyc.aspx"
                : "https://www.intlsecurities.ae/kyc.aspx"
            }
            // style={{ textDecoration: "underline" }}
            target="_blank"
          >
            {t("KYCLink")}
          </a>
        </div>

        <div className="form-group form-group-btns">
          <button
            tabIndex="6"
            className="auth-btns btn btn-primary customBtn"
            style={{ width: "100%" }}
            onClick={(e) => handleSubmit(e)}
            disabled={visible}
            type="submit"
          >
            {t("Login")}
          </button>
          {/* <button
                        className="auth-btns btn btn-signup"
                        onClick={signupBtnClicked}
                        disabled={visible}
                    >
                        {t("Signup")}
                    </button> */}
        </div>
        {localStorage
          .getItem(Constants.localStorageConstants.EnableIPOQuickSell)
          .toUpperCase() === "TRUE" ? (
          <div>
            <button
              tabIndex="7"
              className="auth-btns btn btn-primary customBtn"
              style={{ width: "100%", marginBottom: "1rem" }}
              onClick={(e) => {
                localStorage.setItem("SellIPOSharesAccess", "Y");
                setRedirect(AppUrls.SellIPOShares)
              }
              }
              disabled={visible}
              type="submit"
            >
              {t("IPO_Authintication")}
            </button>
            {/* <button
                        className="auth-btns btn btn-signup"
                        onClick={signupBtnClicked}
                        disabled={visible}
                    >
                        {t("Signup")}
                    </button> */}
          </div>
        ) : null}

        <div
          className={localizationBtnClass + " langBtn"}
          style={{ float: localizationBtnFloat }}
        >
          <button
            tabIndex="8"
            className="language-btn mr  langSHARJAH"
            type="button"
            onClick={(e) => changeLanguageNew(e)}
            disabled={visible}
          >
            <i className="fa fa-language language-icon " aria-hidden="true"></i>
            <div className="language-btn-text">{t("localizationLanguage")}</div>
          </button>
        </div>

        {localStorage.getItem(Constants.localStorageConstants.company_name) ===
          "ADCB" ? (
          <div className="SIFSKYCLink">
            <a
              className="checkbox-localized-text"
              target="_blank"
              href={AppUrls.onboarding}
            >
              {t("SIFSKYCLink")}
            </a>
          </div>
        ) : null}
        {/* {localStorage.getItem(Constants.localStorageConstants.EnableIPOQuickSell).toUpperCase() === "TRUE"  ?
                    <div style={{ float: i18n.language === "ar" ? "right" : "left", marginTop: "-1%" }}>
                        <button
                            type='button'
                            className={"link"}
                            style={{
                                fontWeight: "500",
                                marginLeft: "10px",
                                marginRight: "10px",
                                backgroundColor: "transparent",
                                border: "none",
                                cursor: "pointer",
                                textDecoration : "underline"
                            }}
                            onClick={
                                (event) => {
                                    event.preventDefault();
                                    setRedirect(AppUrls.SellIPOShares)
                                }}
                        >
                            {t("IPO_Authintication")}
                        </button>
                    </div>
                    : null} */}
      </form>
      {localStorage.getItem(Constants.localStorageConstants.company_name) ===
        "ALRAMZ" ? (
        <a
          style={{ width: "100%" }}
          href="https://openaccount.alramz.ae/"
          target="_blank"
        >
          <button
            className="auth-btns btn btn-primary customBtn"
            style={{ width: "100%", marginTop: "-170px" }}
            //onClick={signupBtnClicked}
            disabled={visible}
          >
            {t("Signup")}
          </button>{" "}
        </a>
      ) : null}
      <div className="login_Desc">
        <input type="hidden" value="something" />
        <div className="center">
          <div
            className="form-group container-input-with-password"
            style={{
              textAlign: "right",
              marginBottom: "34px",
              paddingRight: paddingRight,
              paddingLeft: paddingleft2,
            }}
          >
            <p className="login_Desc_Text_Arabic">
              {" "}
              عزيزي العميل
              <br /> الرجاء إستخدام الرابط أدناه للتداول في الأسواق العالمية{" "}
            </p>
          </div>
          <div
            className="form-group"
            style={{
              textAlign: "left",
              paddingLeft: paddingleft,
              paddingRight: paddingRight2,
            }}
          >
            {window.innerWidth > 2500 ? (
              <p className="login_Desc_Text">
                Dear Client
                <br /> Click the Below Link to TRADE INTERNATIONAL MARKETS
              </p>
            ) : (
              <p className="login_Desc_Text">
                Dear Client
                <br /> Click the Below Link to TRADE <br /> INTERNATIONAL
                MARKETS
              </p>
            )}
          </div>
        </div>

        <div className="form-group form-group-btns">
          <a href="https://e-tadawul.globaltradingnetwork.com" target="_blank">
            <button
              tabIndex="9"
              className="auth-btns btn btn-primary Internationalmarketlogin"
              disabled={visible}
            >
              {t("Internationalmarketlogin")}
            </button>
          </a>
        </div>
      </div>
      {localStorage.getItem(Constants.localStorageConstants.company_name) ===
        "ADCB" ? (
        <div className="login_Desc_ADCB">
          <h4>{t("loginFooter1")}</h4>
          <h6>{t("loginFooter2")}</h6>
          <p>{t("loginFooter3")}</p>
          <h6>{t("loginFooter4")}</h6>
          <p>{t("loginFooter5")}</p>
        </div>
      ) : null}
      {localStorage.getItem(Constants.localStorageConstants.company_name) !==
        "SIFS" ? (
        <div
          className={"center-loader  loaderCss " + hideLoader}
          style={{ backgroundColor: "#FFFFFFD9" }}
        >
          <Loader
            type="Bars"
            color="#00BFFF"
            height={100}
            width={100}
            visible={visible}
          />
        </div>
      ) : (
        <div
          className={" center-loader " + hideLoader}
          style={{ height: "100%", width: "100%" }}
        >
          <SpinnersLoadingSIP />
        </div>
      )}

      {localStorage.getItem(Constants.localStorageConstants.company_name) ===
        "SIFS" ||
        localStorage.getItem(Constants.localStorageConstants.company_name) ===
        "QSC" ||
        localStorage.getItem(Constants.localStorageConstants.company_name) ===
        "BHM" ? (
        i18n.language === "ar" ? (
          <div
            className="SecurityTipsDiv"
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div className="sec-block card-rows">
              <h2>
                <oe-i18n-msg msgid="l_SecurityTipsBeware">
                  نصائح أمنية، كن حذراً!
                </oe-i18n-msg>
              </h2>
              <div className="sec-item">
                <img className="sec-img" src={ico} />
                <span className="fontSizeAR">
                  {" "}
                  يرجى الدخول إلى خدمة التداول الإلكتروني التابعة للشارقة
                  الإسلامي للخدمات المالية فقط عبر &nbsp;
                  <a
                    className=""
                    href="https://www.sifs.ae/"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#fff" }}
                  >
                    www.sifs.ae
                  </a>
                </span>
              </div>
              <div className="sec-item">
                <img className="sec-img" src={ico2} />
                <span className="fontSizeAR">
                  <oe-i18n-msg msgid="l_SecurityTips2">
                    لا تشارك معلوماتك الشخصية مثل رقم ملف التداول، اسم المستخدم
                    لخدمة الأونلاين والموبايل، كلمة السر أو الرمز المؤقت OTP
                    رداً على أي رسالة نصية، بريد إلكتروني أو مكالمة هاتفية
                  </oe-i18n-msg>
                </span>
              </div>
            </div>
            <div
              className="buttons-row"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <a
                className="imgDownloadAppPanel-a"
                href={androidUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="imgDownloadAppPanel"
                  src={googlePlayIcon}
                  alt="Google Play"
                />
              </a>
              <a href={iosUrl} target="_blank" rel="noopener noreferrer">
                <img
                  className="imgDownloadAppPanel"
                  src={appStoreIcon}
                  alt="App Store"
                />
              </a>
            </div>
          </div>
        ) : (
          <div
            className="SecurityTipsDiv"
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <div className="sec-block card-rows">
              <h2>
                <oe-i18n-msg msgid="l_SecurityTipsBeware">
                  Security Tips, beware!
                </oe-i18n-msg>
              </h2>
              <div className="sec-item">
                <img className="sec-img" src={ico} />
                <span>
                  Login to{" "}
                  {localStorage.getItem(
                    Constants.localStorageConstants.company_name
                  ) || "SIFS"}{" "}
                  eTrade only through &nbsp;
                  <a
                    href={
                      localStorage.getItem(Constants.localStorageConstants.company_name) === "QSC"
                        ? "https://qatar-securities.com/"
                        : localStorage.getItem(Constants.localStorageConstants.company_name) === "BHM"
                          ? "https://www.bhmuae.ae/"
                          : "https://www.sifs.ae/"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ color: "#fff" }}
                  >
                    {localStorage.getItem(Constants.localStorageConstants.company_name) === "QSC"
                      ? "www.qatar-securities.com"
                      : localStorage.getItem(Constants.localStorageConstants.company_name) === "BHM"
                        ? "www.bhmuae.ae"
                        : "www.sifs.ae"}
                  </a>
                  {" "}
                </span>
              </div>
              <div className="sec-item">
                <img className="sec-img" src={ico2} />
                <span>
                  <oe-i18n-msg msgid="l_SecurityTips2">
                    Do NOT share any sensitive information like Trading file
                    number, Online/Mobile App User ID, Password or OTP in
                    response to SMS, Email or Call Queries
                  </oe-i18n-msg>
                </span>
              </div>
            </div>
            <div
              className="buttons-row"
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                gap: "20px",
              }}
            >
              <a
                className="imgDownloadAppPanel-a"
                href={androidUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  className="imgDownloadAppPanel"
                  src={googlePlayIcon}
                  alt="Google Play"
                />
              </a>
              <a href={iosUrl} target="_blank" rel="noopener noreferrer">
                <img
                  className="imgDownloadAppPanel"
                  src={appStoreIcon}
                  alt="App Store"
                />
              </a>
            </div>
          </div>
        )
      ) : null}
    </div>
  );
}

export default Login;
